import { render, staticRenderFns } from "./MessageIncomingAudio.vue?vue&type=template&id=39af8d1c&"
import script from "./MessageIncomingAudio.vue?vue&type=script&lang=js&"
export * from "./MessageIncomingAudio.vue?vue&type=script&lang=js&"
import style0 from "./MessageIncomingAudio.vue?vue&type=style&index=0&id=39af8d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports